module.exports = __webpack_public_path__ + "static/media/MC Headshot.1d08e5b0.jpg";